import React from "react";
import { Link } from "react-router-dom";
import { mediaUrl } from "../lib/api";

// Deterministic gradient per slug — beautiful fallback when a post has no cover
const GRADIENTS = [
  ["#2C1139", "#FF5A36"],
  ["#3A1748", "#C5A059"],
  ["#1c0a25", "#FF7A47"],
  ["#4a1e5c", "#FFB86B"],
  ["#2C1139", "#B77E4B"],
];
function pickGradient(seed = "") {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return GRADIENTS[h % GRADIENTS.length];
}

export default function PostCard({ post, size = "md" }) {
  const cover = mediaUrl(post.cover_image_id, "desktop") || post.cover_url;
  const catName = post.categories?.[0];
  const large = size === "lg";
  const [g1, g2] = pickGradient(post.slug || post.title || "");

  return (
    <article className="post-card group" data-testid={`post-card-${post.slug}`}>
      <Link to={`/artigo/${post.slug}`} className="block">
        <div className="overflow-hidden bg-[#EFEAE0] aspect-[3/2] rounded-md">
          {cover ? (
            <img
              src={cover}
              alt={post.title}
              loading="lazy"
              decoding="async"
              width="600"
              height="400"
              className="post-card-image w-full h-full object-cover"
            />
          ) : (
            <div
              className="post-card-image w-full h-full grain flex items-end p-4"
              style={{ background: `linear-gradient(135deg, ${g1} 0%, ${g2} 100%)` }}
            >
              {catName && (
                <span className="text-[10px] uppercase tracking-[0.3em] text-white/90 font-semibold">
                  {catName}
                </span>
              )}
            </div>
          )}
        </div>
        <div className="pt-3 md:pt-4">
          {catName && (
            <div className="cat-chip mb-1 md:mb-1.5 text-[9px] md:text-[10px]" data-testid="post-card-category">
              {catName}
            </div>
          )}
          <h3
            className={`font-serif font-semibold text-orion-purple leading-[1.2] group-hover:text-orion-orange transition-colors ${
              large ? "text-xl md:text-3xl" : "text-[15px] md:text-lg"
            }`}
          >
            {post.title}
          </h3>
          {post.excerpt && (
            <p className="mt-1.5 md:mt-2 text-[12px] md:text-[14px] text-[#594A63] leading-relaxed line-clamp-2">
              {post.excerpt}
            </p>
          )}
          <div className="mt-2 md:mt-3 text-[9px] md:text-[10px] uppercase tracking-[0.2em] text-[#8A8191]">
            {post.author || "Equipe Viagens Orion"}
            {post.published_at &&
              ` · ${new Date(post.published_at).toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}`}
          </div>
        </div>
      </Link>
    </article>
  );
}
